import React, { useMemo } from 'react';
import { Flex, Text } from '@chakra-ui/react';
import { useGameColorsProvider } from '../../../providers/Theme/gameColorsProvider';

export enum SpecificHeaderInfoVariant {
	SMALL,
	MEDIUM,
}

interface IFontSize {
	fontSize: string;
	lineHeight: string;
}

export const SpecificHeaderInfo = ({
	variant = SpecificHeaderInfoVariant.MEDIUM,
	text,
	body,
}: {
	variant?: SpecificHeaderInfoVariant;
	text: string;
	body: React.ReactNode;
}) => {
	const { textColor } = useGameColorsProvider();

	const Body = ({ spacing, title, content }: { spacing: string; title: IFontSize; content: IFontSize }) => (
		<Flex
			gridGap={spacing}
			flexDirection="column"
			alignItems="flex-start"
		>
			<Text
				color={`${textColor}99`}
				fontSize={title.fontSize}
				lineHeight={title.lineHeight}
				userSelect="none"
			>
				{text}
			</Text>
			<Flex
				fontSize={content.fontSize}
				lineHeight={content.lineHeight}
				fontWeight="600"
				flexDirection="column"
				gridGap="2px"
			>
				{body}
			</Flex>
		</Flex>
	);

	const typeOptions: any = {
		[SpecificHeaderInfoVariant.SMALL]: () => (
			<Body
				spacing="4px"
				title={{ fontSize: '10px', lineHeight: '13px' }}
				content={{ fontSize: '12px', lineHeight: '15px' }}
			/>
		),
		[SpecificHeaderInfoVariant.MEDIUM]: () => (
			<Body
				spacing="8px"
				title={{ fontSize: '9px', lineHeight: '11px' }}
				content={{ fontSize: '11px', lineHeight: '14px' }}
			/>
		),
	};

	const connectType = useMemo(() => {
		if (variant === SpecificHeaderInfoVariant.SMALL) {
			return SpecificHeaderInfoVariant.SMALL;
		}
		if (variant === SpecificHeaderInfoVariant.MEDIUM) {
			return SpecificHeaderInfoVariant.MEDIUM;
		}
		return SpecificHeaderInfoVariant.MEDIUM;
	}, [variant]);

	return typeOptions[connectType]();
};
